import { disqualificationSteps } from "./disqualificationSteps";
import { sharedSteps } from "./sharedSteps";
import { emailStep } from "./emailStep";
import { getAllSteps } from "../flows";
import { Steps } from "./types";

export const onboardingGraph: Steps = {
  ...sharedSteps,
  ...disqualificationSteps,
  ...getAllSteps(),
  ...emailStep,
};
